import { FormikProps } from 'formik'
import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

import {
  CreateDemoTradingAccountFormValues,
  OuterProps,
} from '@pages/Traders-Room/Trading-Accounts/NewTradingAccount/Demo/CreateDemoTradingAccount.types'
import { useModals } from '@pages/Traders-Room/Trading-Accounts/NewTradingAccount/Demo/CreateDemoTradingAccountModals'
import {
  useLeverageSelect,
  useNewTradingAccountDemoData,
} from '@pages/Traders-Room/Trading-Accounts/NewTradingAccount/Demo/hooks/index'

import { useWindowResize } from '@utils/domUtils'

export const usePreselectEffect = (
  props: FormikProps<CreateDemoTradingAccountFormValues> & OuterProps,
  dataProps: ReturnType<typeof useNewTradingAccountDemoData>,
  modalProps: ReturnType<typeof useModals>
) => {
  const { values, setFieldValue } = props
  const { isClassificationTypeVisible } = dataProps
  const { accountTypes } = modalProps

  const isMobile = useWindowResize()
  const location = useLocation()

  const { leverageType } = useLeverageSelect(values.platformType)

  useEffect(() => {
    values?.platformType?.id && selectFirstCurrency()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.currencies, values?.platformType?.id])

  const selectFirstCurrency = () => {
    const [currentCurrency] = props.currencies
    const currency = props.currencies?.length === 1 ? currentCurrency : undefined
    setFieldValue('accountCurrency', currency)
  }

  useEffect(() => {
    values?.accountCurrency?.id && selectFirstAccountType()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values?.accountCurrency?.id, accountTypes])

  const selectFirstAccountType = () => {
    const [accountType] = accountTypes
    const newAccountType = accountTypes.length === 1 ? accountType : undefined
    if (newAccountType?.id !== values.accountType?.id) {
      if (newAccountType) {
        setFieldValue('accountType', newAccountType)
      }

      if (newAccountType?.id === undefined && values.accountType?.id) {
        setFieldValue('accountType', undefined)
      }
    }
  }

  useEffect(() => {
    values?.accountType?.id && selectFirstLeverageType()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values.platformType?.id, values?.accountType?.id, leverageType?.id])

  const selectFirstLeverageType = async () => {
    if (values?.accountType?.id && values.platformType?.id && !values.leverageType?.id) {
      const newLeverageType = leverageType
      setFieldValue('leverageType', newLeverageType)
    }
  }

  useEffect(() => {
    values?.platformType?.id && selectFirstClassificationType()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values.accountType?.id, values.leverageType?.id, modalProps.classificationTypes])

  const selectFirstClassificationType = () => {
    const [classificationType] = modalProps.classificationTypes
    const classificationTypeOne =
      modalProps.classificationTypes.length === 1 ? classificationType : undefined
    const isNewClassificationTypeVisible = [
      values.platformType?.id,
      values.accountCurrency?.id,
      values.accountType?.id,
      values.leverageType?.id,
      isClassificationTypeVisible,
      classificationTypeOne,
    ].every(Boolean)

    const newClassificationType = isNewClassificationTypeVisible ? classificationTypeOne : undefined
    setFieldValue('classificationType', newClassificationType)
  }

  const restorePreviousValues = () => {
    if (!isMobile || !location.state?.previousValues || !location.state?.selectedPlatformType) {
      return
    }

    if (values.platformType?.id !== location.state.selectedPlatformType.id) {
      setFieldValue('platformType', location.state.selectedPlatformType, false)
    }

    const currentPlatformType = location.state.selectedPlatformType
    if (currentPlatformType) {
      modalProps.handleSetTradingPlatform(currentPlatformType)
    }

    if (location.state.previousValues.platformType?.id === location.state.selectedPlatformType.id) {
      if (values.accountCurrency?.id !== location.state.previousValues.accountCurrency?.id) {
        setFieldValue('accountCurrency', location.state.previousValues.accountCurrency, false)
      }
      if (values.virtualDeposit !== location.state.previousValues.virtualDeposit) {
        setFieldValue('virtualDeposit', location.state.previousValues.virtualDeposit)
      }
      if (values.leverageType?.id !== location.state.previousValues.leverageType?.id) {
        setFieldValue('leverageType', location.state.previousValues.leverageType, false)
      }
      if (!values.accountType) {
        setFieldValue('accountType', location.state.previousValues.accountType, false)
      }
    }
  }

  useEffect(() => {
    restorePreviousValues()
  }, [location.state?.selectedPlatformType])
}
